// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3cDDlVbib-11ls {\n  min-height: 44px;\n  max-height: 44px;\n  overflow: hidden;\n}\n.vhkqoV2Gu547hB {\n  min-height: 70px;\n  max-height: 70px;\n  overflow: hidden;\n}\n@media (min-width: 992px) {\n  .vhkqoV2Gu547hB {\n    min-height: 60px;\n    max-height: 60px;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_3cDDlVbib-11ls",
	"loggedOutHeader": "vhkqoV2Gu547hB"
};
export default ___CSS_LOADER_EXPORT___;
